import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Link } from '@/components/links';
import { Button, FAQs, Hint, Image, OrderedList, Paragraph, SemiBold, SubHeader, Table, TagsList, UnorderedList } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(457);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-about-payment-on-delivery");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoPaymentOnDelivery", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 5
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 5>;
      return {
        question: t(`seoPaymentOnDelivery:sections.faqs.${faqIndex}.question`),
        answer: t(`seoPaymentOnDelivery:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoPaymentOnDelivery:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoPaymentOnDelivery:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoPaymentOnDelivery:header.title">{t6}</Trans>;
    t8 = t("seoPaymentOnDelivery:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  let t12;
  if ($[17] !== t) {
    t11 = <Trans i18nKey="seoPaymentOnDelivery:sections.1.content" t={t} components={t10} />;
    t12 = t("seoPaymentOnDelivery:sections.1.title");
    $[17] = t;
    $[18] = t11;
    $[19] = t12;
  } else {
    t11 = $[18];
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = {
      content: t11,
      title: t12
    };
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = <Trans i18nKey="seoPaymentOnDelivery:sections.2.content" t={t} components={t14} />;
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [...Array(7)];
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t) {
    t17 = <OrderedList items={t16.map((value, i) => {
      const transIndex = i + 1 as NumericRange<1, 7>;
      return <Trans key={i} t={t} i18nKey={`seoPaymentOnDelivery:sections.2.list.${transIndex}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[27] = t;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t15 || $[30] !== t17) {
    t18 = <>{t15}{t17}</>;
    $[29] = t15;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t) {
    t19 = t("seoPaymentOnDelivery:sections.2.title");
    $[32] = t;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t18 || $[35] !== t19) {
    t20 = {
      content: t18,
      title: t19
    };
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Paragraph />;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  let t23;
  if ($[38] !== t) {
    t22 = <Trans i18nKey="seoPaymentOnDelivery:sections.3.content" t={t}>{t21}</Trans>;
    t23 = t("seoPaymentOnDelivery:sections.3.title");
    $[38] = t;
    $[39] = t22;
    $[40] = t23;
  } else {
    t22 = $[39];
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t22 || $[42] !== t23) {
    t24 = {
      content: t22,
      title: t23
    };
    $[41] = t22;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Paragraph />;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t) {
    t26 = <Trans i18nKey="seoPaymentOnDelivery:sections.4.content" t={t}>{t25}</Trans>;
    $[45] = t;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = [...Array(5)];
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== t) {
    t28 = t27.map((value_0, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 5>;
      return <Trans key={i_0} t={t} i18nKey={`seoPaymentOnDelivery:sections.4.subsections.${transIndex_0}`} components={{
        paragraph: <Paragraph />,
        subheader: <SubHeader />
      }} />;
    });
    $[48] = t;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t26 || $[51] !== t28) {
    t29 = <>{t26}{t28}</>;
    $[50] = t26;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t) {
    t30 = t("seoPaymentOnDelivery:sections.4.title");
    $[53] = t;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== t29 || $[56] !== t30) {
    t31 = {
      content: t29,
      title: t30
    };
    $[55] = t29;
    $[56] = t30;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  let t34;
  if ($[59] !== t) {
    t33 = <><Trans i18nKey="seoPaymentOnDelivery:sections.5.content" t={t} components={t32} /></>;
    t34 = t("seoPaymentOnDelivery:sections.5.title");
    $[59] = t;
    $[60] = t33;
    $[61] = t34;
  } else {
    t33 = $[60];
    t34 = $[61];
  }
  let t35;
  if ($[62] !== t33 || $[63] !== t34) {
    t35 = {
      content: t33,
      title: t34
    };
    $[62] = t33;
    $[63] = t34;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      paragraph: <Paragraph />
    };
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== t) {
    t37 = <Trans i18nKey="seoPaymentOnDelivery:sections.6.content" t={t} components={t36} />;
    $[66] = t;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = [...Array(4)];
    $[68] = t38;
  } else {
    t38 = $[68];
  }
  let t39;
  if ($[69] !== t) {
    t39 = <UnorderedList items={t38.map((value_1, i_1) => {
      const transIndex_1 = i_1 + 1 as NumericRange<1, 4>;
      return <Trans key={i_1} t={t} i18nKey={`seoPaymentOnDelivery:sections.6.list.${transIndex_1}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    $[69] = t;
    $[70] = t39;
  } else {
    t39 = $[70];
  }
  let t40;
  if ($[71] !== t37 || $[72] !== t39) {
    t40 = <>{t37}{t39}</>;
    $[71] = t37;
    $[72] = t39;
    $[73] = t40;
  } else {
    t40 = $[73];
  }
  let t41;
  if ($[74] !== t) {
    t41 = t("seoPaymentOnDelivery:sections.6.title");
    $[74] = t;
    $[75] = t41;
  } else {
    t41 = $[75];
  }
  let t42;
  if ($[76] !== t40 || $[77] !== t41) {
    t42 = {
      content: t40,
      title: t41
    };
    $[76] = t40;
    $[77] = t41;
    $[78] = t42;
  } else {
    t42 = $[78];
  }
  let t43;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = {
      paragraph: <Paragraph />
    };
    $[79] = t43;
  } else {
    t43 = $[79];
  }
  let t44;
  if ($[80] !== t) {
    t44 = <Trans i18nKey="seoPaymentOnDelivery:sections.7.content1" t={t} components={t43} />;
    $[80] = t;
    $[81] = t44;
  } else {
    t44 = $[81];
  }
  let t45;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = [...Array(8)];
    $[82] = t45;
  } else {
    t45 = $[82];
  }
  let t46;
  if ($[83] !== t) {
    t46 = <TagsList items={t45.map((value_2, i_2) => {
      const transIndex_2 = i_2 + 1 as NumericRange<1, 8>;
      return <Trans key={i_2} t={t} i18nKey={`seoPaymentOnDelivery:sections.7.list1.${transIndex_2}`} />;
    })} className="mb-6 lg:mb-8" />;
    $[83] = t;
    $[84] = t46;
  } else {
    t46 = $[84];
  }
  let t47;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = {
      paragraph: <Paragraph />
    };
    $[85] = t47;
  } else {
    t47 = $[85];
  }
  let t48;
  if ($[86] !== t) {
    t48 = <Trans i18nKey="seoPaymentOnDelivery:sections.7.content2" t={t} components={t47} />;
    $[86] = t;
    $[87] = t48;
  } else {
    t48 = $[87];
  }
  let t49;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = [...Array(3)];
    $[88] = t49;
  } else {
    t49 = $[88];
  }
  let t50;
  if ($[89] !== t) {
    t50 = <TagsList items={t49.map((value_3, i_3) => {
      const transIndex_3 = i_3 + 1 as NumericRange<1, 3>;
      return <Trans key={i_3} t={t} i18nKey={`seoPaymentOnDelivery:sections.7.list2.${transIndex_3}`} />;
    })} />;
    $[89] = t;
    $[90] = t50;
  } else {
    t50 = $[90];
  }
  let t51;
  if ($[91] !== t44 || $[92] !== t46 || $[93] !== t48 || $[94] !== t50) {
    t51 = <>{t44}{t46}{t48}{t50}</>;
    $[91] = t44;
    $[92] = t46;
    $[93] = t48;
    $[94] = t50;
    $[95] = t51;
  } else {
    t51 = $[95];
  }
  let t52;
  if ($[96] !== t) {
    t52 = t("seoPaymentOnDelivery:sections.7.title");
    $[96] = t;
    $[97] = t52;
  } else {
    t52 = $[97];
  }
  let t53;
  if ($[98] !== t51 || $[99] !== t52) {
    t53 = {
      content: t51,
      title: t52
    };
    $[98] = t51;
    $[99] = t52;
    $[100] = t53;
  } else {
    t53 = $[100];
  }
  let t54;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = {
      paragraph: <Paragraph />
    };
    $[101] = t54;
  } else {
    t54 = $[101];
  }
  let t55;
  if ($[102] !== t) {
    t55 = <Trans i18nKey="seoPaymentOnDelivery:sections.8.content1" t={t} components={t54} />;
    $[102] = t;
    $[103] = t55;
  } else {
    t55 = $[103];
  }
  let t56;
  if ($[104] !== t) {
    t56 = t("seoPaymentOnDelivery:sections.8.table.header");
    $[104] = t;
    $[105] = t56;
  } else {
    t56 = $[105];
  }
  let t57;
  if ($[106] !== t56) {
    t57 = <tr><th colSpan={7} className="w-192">{t56}</th></tr>;
    $[106] = t56;
    $[107] = t57;
  } else {
    t57 = $[107];
  }
  let t58;
  if ($[108] !== t) {
    t58 = t("seoPaymentOnDelivery:sections.8.table.sections.1.title");
    $[108] = t;
    $[109] = t58;
  } else {
    t58 = $[109];
  }
  let t59;
  if ($[110] !== t58) {
    t59 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t58}</td></tr>;
    $[110] = t58;
    $[111] = t59;
  } else {
    t59 = $[111];
  }
  let t60;
  if ($[112] !== t) {
    t60 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.1");
    $[112] = t;
    $[113] = t60;
  } else {
    t60 = $[113];
  }
  let t61;
  if ($[114] !== t60) {
    t61 = <td className="w-42">{t60}</td>;
    $[114] = t60;
    $[115] = t61;
  } else {
    t61 = $[115];
  }
  let t62;
  if ($[116] !== t) {
    t62 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.2");
    $[116] = t;
    $[117] = t62;
  } else {
    t62 = $[117];
  }
  let t63;
  if ($[118] !== t62) {
    t63 = <td colSpan={2} className="w-50">{t62}</td>;
    $[118] = t62;
    $[119] = t63;
  } else {
    t63 = $[119];
  }
  let t64;
  if ($[120] !== t) {
    t64 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.3");
    $[120] = t;
    $[121] = t64;
  } else {
    t64 = $[121];
  }
  let t65;
  if ($[122] !== t64) {
    t65 = <td colSpan={2} className="w-50">{t64}</td>;
    $[122] = t64;
    $[123] = t65;
  } else {
    t65 = $[123];
  }
  let t66;
  if ($[124] !== t) {
    t66 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.1.columns.4");
    $[124] = t;
    $[125] = t66;
  } else {
    t66 = $[125];
  }
  let t67;
  if ($[126] !== t66) {
    t67 = <td colSpan={2} className="w-50">{t66}</td>;
    $[126] = t66;
    $[127] = t67;
  } else {
    t67 = $[127];
  }
  let t68;
  if ($[128] !== t61 || $[129] !== t63 || $[130] !== t65 || $[131] !== t67) {
    t68 = <tr>{t61}{t63}{t65}{t67}</tr>;
    $[128] = t61;
    $[129] = t63;
    $[130] = t65;
    $[131] = t67;
    $[132] = t68;
  } else {
    t68 = $[132];
  }
  let t69;
  if ($[133] !== t) {
    t69 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.1");
    $[133] = t;
    $[134] = t69;
  } else {
    t69 = $[134];
  }
  let t70;
  if ($[135] !== t69) {
    t70 = <td className="w-42">{t69}</td>;
    $[135] = t69;
    $[136] = t70;
  } else {
    t70 = $[136];
  }
  let t71;
  if ($[137] !== t) {
    t71 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.2");
    $[137] = t;
    $[138] = t71;
  } else {
    t71 = $[138];
  }
  let t72;
  if ($[139] !== t71) {
    t72 = <td colSpan={2} className="w-50">{t71}</td>;
    $[139] = t71;
    $[140] = t72;
  } else {
    t72 = $[140];
  }
  let t73;
  if ($[141] !== t) {
    t73 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.3");
    $[141] = t;
    $[142] = t73;
  } else {
    t73 = $[142];
  }
  let t74;
  if ($[143] !== t73) {
    t74 = <td colSpan={2} className="w-50">{t73}</td>;
    $[143] = t73;
    $[144] = t74;
  } else {
    t74 = $[144];
  }
  let t75;
  if ($[145] !== t) {
    t75 = t("seoPaymentOnDelivery:sections.8.table.sections.1.rows.2.columns.4");
    $[145] = t;
    $[146] = t75;
  } else {
    t75 = $[146];
  }
  let t76;
  if ($[147] !== t75) {
    t76 = <td colSpan={2} className="w-50">{t75}</td>;
    $[147] = t75;
    $[148] = t76;
  } else {
    t76 = $[148];
  }
  let t77;
  if ($[149] !== t70 || $[150] !== t72 || $[151] !== t74 || $[152] !== t76) {
    t77 = <tr>{t70}{t72}{t74}{t76}</tr>;
    $[149] = t70;
    $[150] = t72;
    $[151] = t74;
    $[152] = t76;
    $[153] = t77;
  } else {
    t77 = $[153];
  }
  let t78;
  if ($[154] !== t) {
    t78 = t("seoPaymentOnDelivery:sections.8.table.sections.2.title");
    $[154] = t;
    $[155] = t78;
  } else {
    t78 = $[155];
  }
  let t79;
  if ($[156] !== t78) {
    t79 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t78}</td></tr>;
    $[156] = t78;
    $[157] = t79;
  } else {
    t79 = $[157];
  }
  let t80;
  if ($[158] !== t) {
    t80 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.1");
    $[158] = t;
    $[159] = t80;
  } else {
    t80 = $[159];
  }
  let t81;
  if ($[160] !== t80) {
    t81 = <td className="w-42">{t80}</td>;
    $[160] = t80;
    $[161] = t81;
  } else {
    t81 = $[161];
  }
  let t82;
  if ($[162] !== t) {
    t82 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.2");
    $[162] = t;
    $[163] = t82;
  } else {
    t82 = $[163];
  }
  let t83;
  if ($[164] !== t82) {
    t83 = <td className="w-25">{t82}</td>;
    $[164] = t82;
    $[165] = t83;
  } else {
    t83 = $[165];
  }
  let t84;
  if ($[166] !== t) {
    t84 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.3");
    $[166] = t;
    $[167] = t84;
  } else {
    t84 = $[167];
  }
  let t85;
  if ($[168] !== t84) {
    t85 = <td className="w-25">{t84}</td>;
    $[168] = t84;
    $[169] = t85;
  } else {
    t85 = $[169];
  }
  let t86;
  if ($[170] !== t) {
    t86 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.4");
    $[170] = t;
    $[171] = t86;
  } else {
    t86 = $[171];
  }
  let t87;
  if ($[172] !== t86) {
    t87 = <td className="w-25">{t86}</td>;
    $[172] = t86;
    $[173] = t87;
  } else {
    t87 = $[173];
  }
  let t88;
  if ($[174] !== t) {
    t88 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.5");
    $[174] = t;
    $[175] = t88;
  } else {
    t88 = $[175];
  }
  let t89;
  if ($[176] !== t88) {
    t89 = <td className="w-25">{t88}</td>;
    $[176] = t88;
    $[177] = t89;
  } else {
    t89 = $[177];
  }
  let t90;
  if ($[178] !== t) {
    t90 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.6");
    $[178] = t;
    $[179] = t90;
  } else {
    t90 = $[179];
  }
  let t91;
  if ($[180] !== t90) {
    t91 = <td className="w-25">{t90}</td>;
    $[180] = t90;
    $[181] = t91;
  } else {
    t91 = $[181];
  }
  let t92;
  if ($[182] !== t) {
    t92 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.1.columns.7");
    $[182] = t;
    $[183] = t92;
  } else {
    t92 = $[183];
  }
  let t93;
  if ($[184] !== t92) {
    t93 = <td className="w-25">{t92}</td>;
    $[184] = t92;
    $[185] = t93;
  } else {
    t93 = $[185];
  }
  let t94;
  if ($[186] !== t81 || $[187] !== t83 || $[188] !== t85 || $[189] !== t87 || $[190] !== t89 || $[191] !== t91 || $[192] !== t93) {
    t94 = <tr>{t81}{t83}{t85}{t87}{t89}{t91}{t93}</tr>;
    $[186] = t81;
    $[187] = t83;
    $[188] = t85;
    $[189] = t87;
    $[190] = t89;
    $[191] = t91;
    $[192] = t93;
    $[193] = t94;
  } else {
    t94 = $[193];
  }
  let t95;
  if ($[194] !== t) {
    t95 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.1");
    $[194] = t;
    $[195] = t95;
  } else {
    t95 = $[195];
  }
  let t96;
  if ($[196] !== t95) {
    t96 = <td className="w-42">{t95}</td>;
    $[196] = t95;
    $[197] = t96;
  } else {
    t96 = $[197];
  }
  let t97;
  if ($[198] !== t) {
    t97 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.2");
    $[198] = t;
    $[199] = t97;
  } else {
    t97 = $[199];
  }
  let t98;
  if ($[200] !== t97) {
    t98 = <td className="w-25">{t97}</td>;
    $[200] = t97;
    $[201] = t98;
  } else {
    t98 = $[201];
  }
  let t99;
  if ($[202] !== t) {
    t99 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.3");
    $[202] = t;
    $[203] = t99;
  } else {
    t99 = $[203];
  }
  let t100;
  if ($[204] !== t99) {
    t100 = <td className="w-25">{t99}</td>;
    $[204] = t99;
    $[205] = t100;
  } else {
    t100 = $[205];
  }
  let t101;
  if ($[206] !== t) {
    t101 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.4");
    $[206] = t;
    $[207] = t101;
  } else {
    t101 = $[207];
  }
  let t102;
  if ($[208] !== t101) {
    t102 = <td className="w-25">{t101}</td>;
    $[208] = t101;
    $[209] = t102;
  } else {
    t102 = $[209];
  }
  let t103;
  if ($[210] !== t) {
    t103 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.5");
    $[210] = t;
    $[211] = t103;
  } else {
    t103 = $[211];
  }
  let t104;
  if ($[212] !== t103) {
    t104 = <td className="w-25">{t103}</td>;
    $[212] = t103;
    $[213] = t104;
  } else {
    t104 = $[213];
  }
  let t105;
  if ($[214] !== t) {
    t105 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.6");
    $[214] = t;
    $[215] = t105;
  } else {
    t105 = $[215];
  }
  let t106;
  if ($[216] !== t105) {
    t106 = <td className="w-25">{t105}</td>;
    $[216] = t105;
    $[217] = t106;
  } else {
    t106 = $[217];
  }
  let t107;
  if ($[218] !== t) {
    t107 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.7");
    $[218] = t;
    $[219] = t107;
  } else {
    t107 = $[219];
  }
  let t108;
  if ($[220] !== t107) {
    t108 = <td className="w-25">{t107}</td>;
    $[220] = t107;
    $[221] = t108;
  } else {
    t108 = $[221];
  }
  let t109;
  if ($[222] !== t100 || $[223] !== t102 || $[224] !== t104 || $[225] !== t106 || $[226] !== t108 || $[227] !== t96 || $[228] !== t98) {
    t109 = <tr>{t96}{t98}{t100}{t102}{t104}{t106}{t108}</tr>;
    $[222] = t100;
    $[223] = t102;
    $[224] = t104;
    $[225] = t106;
    $[226] = t108;
    $[227] = t96;
    $[228] = t98;
    $[229] = t109;
  } else {
    t109 = $[229];
  }
  let t110;
  if ($[230] !== t) {
    t110 = t("seoPaymentOnDelivery:sections.8.table.sections.3.title");
    $[230] = t;
    $[231] = t110;
  } else {
    t110 = $[231];
  }
  let t111;
  if ($[232] !== t110) {
    t111 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t110}</td></tr>;
    $[232] = t110;
    $[233] = t111;
  } else {
    t111 = $[233];
  }
  let t112;
  if ($[234] !== t) {
    t112 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.1");
    $[234] = t;
    $[235] = t112;
  } else {
    t112 = $[235];
  }
  let t113;
  if ($[236] !== t112) {
    t113 = <td className="w-42">{t112}</td>;
    $[236] = t112;
    $[237] = t113;
  } else {
    t113 = $[237];
  }
  let t114;
  if ($[238] !== t) {
    t114 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.2");
    $[238] = t;
    $[239] = t114;
  } else {
    t114 = $[239];
  }
  let t115;
  if ($[240] !== t114) {
    t115 = <td className="w-25">{t114}</td>;
    $[240] = t114;
    $[241] = t115;
  } else {
    t115 = $[241];
  }
  let t116;
  if ($[242] !== t) {
    t116 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.3");
    $[242] = t;
    $[243] = t116;
  } else {
    t116 = $[243];
  }
  let t117;
  if ($[244] !== t116) {
    t117 = <td className="w-25">{t116}</td>;
    $[244] = t116;
    $[245] = t117;
  } else {
    t117 = $[245];
  }
  let t118;
  if ($[246] !== t) {
    t118 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.4");
    $[246] = t;
    $[247] = t118;
  } else {
    t118 = $[247];
  }
  let t119;
  if ($[248] !== t118) {
    t119 = <td className="w-25">{t118}</td>;
    $[248] = t118;
    $[249] = t119;
  } else {
    t119 = $[249];
  }
  let t120;
  if ($[250] !== t) {
    t120 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.5");
    $[250] = t;
    $[251] = t120;
  } else {
    t120 = $[251];
  }
  let t121;
  if ($[252] !== t120) {
    t121 = <td className="w-25">{t120}</td>;
    $[252] = t120;
    $[253] = t121;
  } else {
    t121 = $[253];
  }
  let t122;
  if ($[254] !== t) {
    t122 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.6");
    $[254] = t;
    $[255] = t122;
  } else {
    t122 = $[255];
  }
  let t123;
  if ($[256] !== t122) {
    t123 = <td className="w-25">{t122}</td>;
    $[256] = t122;
    $[257] = t123;
  } else {
    t123 = $[257];
  }
  let t124;
  if ($[258] !== t) {
    t124 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.1.columns.7");
    $[258] = t;
    $[259] = t124;
  } else {
    t124 = $[259];
  }
  let t125;
  if ($[260] !== t124) {
    t125 = <td className="w-25">{t124}</td>;
    $[260] = t124;
    $[261] = t125;
  } else {
    t125 = $[261];
  }
  let t126;
  if ($[262] !== t113 || $[263] !== t115 || $[264] !== t117 || $[265] !== t119 || $[266] !== t121 || $[267] !== t123 || $[268] !== t125) {
    t126 = <tr>{t113}{t115}{t117}{t119}{t121}{t123}{t125}</tr>;
    $[262] = t113;
    $[263] = t115;
    $[264] = t117;
    $[265] = t119;
    $[266] = t121;
    $[267] = t123;
    $[268] = t125;
    $[269] = t126;
  } else {
    t126 = $[269];
  }
  let t127;
  if ($[270] !== t) {
    t127 = t("seoPaymentOnDelivery:sections.8.table.sections.2.rows.2.columns.1");
    $[270] = t;
    $[271] = t127;
  } else {
    t127 = $[271];
  }
  let t128;
  if ($[272] !== t127) {
    t128 = <td className="w-42">{t127}</td>;
    $[272] = t127;
    $[273] = t128;
  } else {
    t128 = $[273];
  }
  let t129;
  if ($[274] !== t) {
    t129 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.2");
    $[274] = t;
    $[275] = t129;
  } else {
    t129 = $[275];
  }
  let t130;
  if ($[276] !== t129) {
    t130 = <td className="w-25">{t129}</td>;
    $[276] = t129;
    $[277] = t130;
  } else {
    t130 = $[277];
  }
  let t131;
  if ($[278] !== t) {
    t131 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.3");
    $[278] = t;
    $[279] = t131;
  } else {
    t131 = $[279];
  }
  let t132;
  if ($[280] !== t131) {
    t132 = <td className="w-25">{t131}</td>;
    $[280] = t131;
    $[281] = t132;
  } else {
    t132 = $[281];
  }
  let t133;
  if ($[282] !== t) {
    t133 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.4");
    $[282] = t;
    $[283] = t133;
  } else {
    t133 = $[283];
  }
  let t134;
  if ($[284] !== t133) {
    t134 = <td className="w-25">{t133}</td>;
    $[284] = t133;
    $[285] = t134;
  } else {
    t134 = $[285];
  }
  let t135;
  if ($[286] !== t) {
    t135 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.5");
    $[286] = t;
    $[287] = t135;
  } else {
    t135 = $[287];
  }
  let t136;
  if ($[288] !== t135) {
    t136 = <td className="w-25">{t135}</td>;
    $[288] = t135;
    $[289] = t136;
  } else {
    t136 = $[289];
  }
  let t137;
  if ($[290] !== t) {
    t137 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.6");
    $[290] = t;
    $[291] = t137;
  } else {
    t137 = $[291];
  }
  let t138;
  if ($[292] !== t137) {
    t138 = <td className="w-25">{t137}</td>;
    $[292] = t137;
    $[293] = t138;
  } else {
    t138 = $[293];
  }
  let t139;
  if ($[294] !== t) {
    t139 = t("seoPaymentOnDelivery:sections.8.table.sections.3.rows.2.columns.7");
    $[294] = t;
    $[295] = t139;
  } else {
    t139 = $[295];
  }
  let t140;
  if ($[296] !== t139) {
    t140 = <td className="w-25">{t139}</td>;
    $[296] = t139;
    $[297] = t140;
  } else {
    t140 = $[297];
  }
  let t141;
  if ($[298] !== t128 || $[299] !== t130 || $[300] !== t132 || $[301] !== t134 || $[302] !== t136 || $[303] !== t138 || $[304] !== t140) {
    t141 = <tr>{t128}{t130}{t132}{t134}{t136}{t138}{t140}</tr>;
    $[298] = t128;
    $[299] = t130;
    $[300] = t132;
    $[301] = t134;
    $[302] = t136;
    $[303] = t138;
    $[304] = t140;
    $[305] = t141;
  } else {
    t141 = $[305];
  }
  let t142;
  if ($[306] !== t) {
    t142 = t("seoPaymentOnDelivery:sections.8.table.sections.4.title");
    $[306] = t;
    $[307] = t142;
  } else {
    t142 = $[307];
  }
  let t143;
  if ($[308] !== t142) {
    t143 = <tr><td colSpan={7} className="w-192 bg-blue-100! uppercase!">{t142}</td></tr>;
    $[308] = t142;
    $[309] = t143;
  } else {
    t143 = $[309];
  }
  let t144;
  if ($[310] !== t) {
    t144 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.1.columns.1");
    $[310] = t;
    $[311] = t144;
  } else {
    t144 = $[311];
  }
  let t145;
  if ($[312] !== t144) {
    t145 = <td className="w-42">{t144}</td>;
    $[312] = t144;
    $[313] = t145;
  } else {
    t145 = $[313];
  }
  let t146;
  if ($[314] !== t) {
    t146 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.1.columns.2");
    $[314] = t;
    $[315] = t146;
  } else {
    t146 = $[315];
  }
  let t147;
  if ($[316] !== t146) {
    t147 = <td colSpan={6} className="w-[37.5rem]">{t146}</td>;
    $[316] = t146;
    $[317] = t147;
  } else {
    t147 = $[317];
  }
  let t148;
  if ($[318] !== t145 || $[319] !== t147) {
    t148 = <tr>{t145}{t147}</tr>;
    $[318] = t145;
    $[319] = t147;
    $[320] = t148;
  } else {
    t148 = $[320];
  }
  let t149;
  if ($[321] !== t) {
    t149 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.2.columns.1");
    $[321] = t;
    $[322] = t149;
  } else {
    t149 = $[322];
  }
  let t150;
  if ($[323] !== t149) {
    t150 = <td className="w-42">{t149}</td>;
    $[323] = t149;
    $[324] = t150;
  } else {
    t150 = $[324];
  }
  let t151;
  if ($[325] !== t) {
    t151 = t("seoPaymentOnDelivery:sections.8.table.sections.4.rows.2.columns.2");
    $[325] = t;
    $[326] = t151;
  } else {
    t151 = $[326];
  }
  let t152;
  if ($[327] !== t151) {
    t152 = <td colSpan={6} className="w-[37.5rem]">{t151}</td>;
    $[327] = t151;
    $[328] = t152;
  } else {
    t152 = $[328];
  }
  let t153;
  if ($[329] !== t150 || $[330] !== t152) {
    t153 = <tr>{t150}{t152}</tr>;
    $[329] = t150;
    $[330] = t152;
    $[331] = t153;
  } else {
    t153 = $[331];
  }
  let t154;
  if ($[332] !== t109 || $[333] !== t111 || $[334] !== t126 || $[335] !== t141 || $[336] !== t143 || $[337] !== t148 || $[338] !== t153 || $[339] !== t59 || $[340] !== t68 || $[341] !== t77 || $[342] !== t79 || $[343] !== t94) {
    t154 = <>{t59}{t68}{t77}{t79}{t94}{t109}{t111}{t126}{t141}{t143}{t148}{t153}</>;
    $[332] = t109;
    $[333] = t111;
    $[334] = t126;
    $[335] = t141;
    $[336] = t143;
    $[337] = t148;
    $[338] = t153;
    $[339] = t59;
    $[340] = t68;
    $[341] = t77;
    $[342] = t79;
    $[343] = t94;
    $[344] = t154;
  } else {
    t154 = $[344];
  }
  let t155;
  if ($[345] !== t) {
    t155 = t("seoPaymentOnDelivery:sections.8.table.note");
    $[345] = t;
    $[346] = t155;
  } else {
    t155 = $[346];
  }
  let t156;
  if ($[347] !== t155) {
    t156 = [t155];
    $[347] = t155;
    $[348] = t156;
  } else {
    t156 = $[348];
  }
  let t157;
  if ($[349] !== t154 || $[350] !== t156 || $[351] !== t57) {
    t157 = <Table head={t57} body={t154} notes={t156} className="mb-6 lg:mb-8" />;
    $[349] = t154;
    $[350] = t156;
    $[351] = t57;
    $[352] = t157;
  } else {
    t157 = $[352];
  }
  let t158;
  if ($[353] === Symbol.for("react.memo_cache_sentinel")) {
    t158 = {
      paragraph: <Paragraph />
    };
    $[353] = t158;
  } else {
    t158 = $[353];
  }
  let t159;
  if ($[354] !== t) {
    t159 = <Trans i18nKey="seoPaymentOnDelivery:sections.8.content2" t={t} components={t158} />;
    $[354] = t;
    $[355] = t159;
  } else {
    t159 = $[355];
  }
  let t160;
  if ($[356] === Symbol.for("react.memo_cache_sentinel")) {
    t160 = {
      link1: <Link analyticsParam="seoPaymentOnDeliveryHintDeferredPayment" testId="seoPaymentOnDeliveryHintDeferredPayment" to={LINKS().aboutDeferredPayment} />
    };
    $[356] = t160;
  } else {
    t160 = $[356];
  }
  let t161;
  if ($[357] !== t) {
    t161 = <Hint text={<Trans t={t} i18nKey="seoPaymentOnDelivery:sections.8.hint" components={t160} />} />;
    $[357] = t;
    $[358] = t161;
  } else {
    t161 = $[358];
  }
  let t162;
  if ($[359] !== t157 || $[360] !== t159 || $[361] !== t161 || $[362] !== t55) {
    t162 = <>{t55}{t157}{t159}{t161}</>;
    $[359] = t157;
    $[360] = t159;
    $[361] = t161;
    $[362] = t55;
    $[363] = t162;
  } else {
    t162 = $[363];
  }
  let t163;
  if ($[364] !== t) {
    t163 = t("seoPaymentOnDelivery:sections.8.title");
    $[364] = t;
    $[365] = t163;
  } else {
    t163 = $[365];
  }
  let t164;
  if ($[366] !== t162 || $[367] !== t163) {
    t164 = {
      content: t162,
      title: t163
    };
    $[366] = t162;
    $[367] = t163;
    $[368] = t164;
  } else {
    t164 = $[368];
  }
  let t165;
  if ($[369] === Symbol.for("react.memo_cache_sentinel")) {
    t165 = [...Array(4)];
    $[369] = t165;
  } else {
    t165 = $[369];
  }
  let t166;
  let t167;
  if ($[370] !== t) {
    t166 = <OrderedList items={t165.map((__0, i_4) => {
      const transIndex_4 = i_4 + 1 as NumericRange<1, 4>;
      return <Trans key={i_4} t={t} i18nKey={`seoPaymentOnDelivery:sections.9.list.${transIndex_4}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    t167 = t("seoPaymentOnDelivery:sections.9.title");
    $[370] = t;
    $[371] = t166;
    $[372] = t167;
  } else {
    t166 = $[371];
    t167 = $[372];
  }
  let t168;
  if ($[373] !== t166 || $[374] !== t167) {
    t168 = {
      content: t166,
      title: t167
    };
    $[373] = t166;
    $[374] = t167;
    $[375] = t168;
  } else {
    t168 = $[375];
  }
  let t169;
  if ($[376] === Symbol.for("react.memo_cache_sentinel")) {
    t169 = [...Array(4)];
    $[376] = t169;
  } else {
    t169 = $[376];
  }
  let t170;
  let t171;
  if ($[377] !== t) {
    t170 = <OrderedList items={t169.map((__1, i_5) => {
      const transIndex_5 = i_5 + 1 as NumericRange<1, 4>;
      return <Trans key={i_5} t={t} i18nKey={`seoPaymentOnDelivery:sections.10.list.${transIndex_5}`} components={{
        semibold: <SemiBold />
      }} />;
    })} />;
    t171 = t("seoPaymentOnDelivery:sections.10.title");
    $[377] = t;
    $[378] = t170;
    $[379] = t171;
  } else {
    t170 = $[378];
    t171 = $[379];
  }
  let t172;
  if ($[380] !== t170 || $[381] !== t171) {
    t172 = {
      content: t170,
      title: t171
    };
    $[380] = t170;
    $[381] = t171;
    $[382] = t172;
  } else {
    t172 = $[382];
  }
  let t173;
  if ($[383] === Symbol.for("react.memo_cache_sentinel")) {
    t173 = {
      paragraph: <Paragraph />,
      link1: <Link testId="seoPaymentOnDeliveryPost" analyticsParam="seoPaymentOnDeliveryPost" to="https://www.ceskaposta.cz/sluzby/platebni-a-financni-sluzby-cr/postovni-poukazka-a" target="_blank" />,
      link2: <Link testId="seoPaymentOnDeliveryPost2" analyticsParam="seoPaymentOnDeliveryPost2" to="https://www.ceskaposta.cz/sluzby/platebni-a-financni-sluzby-cr/postovni-poukazka-c" target="_blank" />
    };
    $[383] = t173;
  } else {
    t173 = $[383];
  }
  let t174;
  if ($[384] !== t) {
    t174 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.11.content" components={t173} />;
    $[384] = t;
    $[385] = t174;
  } else {
    t174 = $[385];
  }
  let t175;
  if ($[386] !== t) {
    t175 = t("seoPaymentOnDelivery:sections.11.title");
    $[386] = t;
    $[387] = t175;
  } else {
    t175 = $[387];
  }
  let t176;
  if ($[388] !== t175) {
    t176 = <Image src="/images/sections/seoPaymentOnDelivery/cs/post.png" width={768} height={325} alt={t175} />;
    $[388] = t175;
    $[389] = t176;
  } else {
    t176 = $[389];
  }
  let t177;
  if ($[390] !== t174 || $[391] !== t176) {
    t177 = <>{t174}{t176}</>;
    $[390] = t174;
    $[391] = t176;
    $[392] = t177;
  } else {
    t177 = $[392];
  }
  let t178;
  if ($[393] !== t) {
    t178 = t("seoPaymentOnDelivery:sections.11.title");
    $[393] = t;
    $[394] = t178;
  } else {
    t178 = $[394];
  }
  let t179;
  if ($[395] !== t177 || $[396] !== t178) {
    t179 = {
      content: t177,
      title: t178
    };
    $[395] = t177;
    $[396] = t178;
    $[397] = t179;
  } else {
    t179 = $[397];
  }
  let t180;
  if ($[398] === Symbol.for("react.memo_cache_sentinel")) {
    t180 = {
      paragraph: <Paragraph />
    };
    $[398] = t180;
  } else {
    t180 = $[398];
  }
  let t181;
  let t182;
  if ($[399] !== t) {
    t181 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.12.content" components={t180} />;
    t182 = t("seoPaymentOnDelivery:sections.12.title");
    $[399] = t;
    $[400] = t181;
    $[401] = t182;
  } else {
    t181 = $[400];
    t182 = $[401];
  }
  let t183;
  if ($[402] !== t181 || $[403] !== t182) {
    t183 = {
      content: t181,
      title: t182
    };
    $[402] = t181;
    $[403] = t182;
    $[404] = t183;
  } else {
    t183 = $[404];
  }
  let t184;
  if ($[405] === Symbol.for("react.memo_cache_sentinel")) {
    t184 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[405] = t184;
  } else {
    t184 = $[405];
  }
  let t185;
  let t186;
  if ($[406] !== t) {
    t185 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.13.content" components={t184} />;
    t186 = t("seoPaymentOnDelivery:sections.13.title");
    $[406] = t;
    $[407] = t185;
    $[408] = t186;
  } else {
    t185 = $[407];
    t186 = $[408];
  }
  let t187;
  if ($[409] !== t185 || $[410] !== t186) {
    t187 = {
      content: t185,
      title: t186
    };
    $[409] = t185;
    $[410] = t186;
    $[411] = t187;
  } else {
    t187 = $[411];
  }
  let t188;
  if ($[412] === Symbol.for("react.memo_cache_sentinel")) {
    t188 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />,
      br: <br />
    };
    $[412] = t188;
  } else {
    t188 = $[412];
  }
  let t189;
  if ($[413] !== t) {
    t189 = <Trans t={t} i18nKey="seoPaymentOnDelivery:sections.14.content" components={t188} />;
    $[413] = t;
    $[414] = t189;
  } else {
    t189 = $[414];
  }
  let t190;
  if ($[415] === Symbol.for("react.memo_cache_sentinel")) {
    t190 = LINKS();
    $[415] = t190;
  } else {
    t190 = $[415];
  }
  const t191 = t190.registration;
  let t192;
  if ($[416] !== t) {
    t192 = t("seoPaymentOnDelivery:sections.14.button");
    $[416] = t;
    $[417] = t192;
  } else {
    t192 = $[417];
  }
  let t193;
  if ($[418] !== t192) {
    t193 = <Button analyticsParam="seoPaymentOnDeliveryRegistration" testId="seoPaymentOnDeliveryRegistration" to={t191} variant="primary">{t192}</Button>;
    $[418] = t192;
    $[419] = t193;
  } else {
    t193 = $[419];
  }
  let t194;
  if ($[420] !== t189 || $[421] !== t193) {
    t194 = <>{t189}{t193}</>;
    $[420] = t189;
    $[421] = t193;
    $[422] = t194;
  } else {
    t194 = $[422];
  }
  let t195;
  if ($[423] !== t) {
    t195 = t("seoPaymentOnDelivery:sections.14.title");
    $[423] = t;
    $[424] = t195;
  } else {
    t195 = $[424];
  }
  let t196;
  if ($[425] !== t194 || $[426] !== t195) {
    t196 = {
      content: t194,
      title: t195
    };
    $[425] = t194;
    $[426] = t195;
    $[427] = t196;
  } else {
    t196 = $[427];
  }
  let t197;
  if ($[428] !== faqsData) {
    t197 = <FAQs data={faqsData} />;
    $[428] = faqsData;
    $[429] = t197;
  } else {
    t197 = $[429];
  }
  let t198;
  if ($[430] !== t) {
    t198 = t("core:faqs.title");
    $[430] = t;
    $[431] = t198;
  } else {
    t198 = $[431];
  }
  let t199;
  if ($[432] !== t197 || $[433] !== t198) {
    t199 = {
      content: t197,
      title: t198
    };
    $[432] = t197;
    $[433] = t198;
    $[434] = t199;
  } else {
    t199 = $[434];
  }
  let t200;
  if ($[435] !== t13 || $[436] !== t164 || $[437] !== t168 || $[438] !== t172 || $[439] !== t179 || $[440] !== t183 || $[441] !== t187 || $[442] !== t196 || $[443] !== t199 || $[444] !== t20 || $[445] !== t24 || $[446] !== t31 || $[447] !== t35 || $[448] !== t42 || $[449] !== t53) {
    t200 = [t13, t20, t24, t31, t35, t42, t53, t164, t168, t172, t179, t183, t187, t196, t199];
    $[435] = t13;
    $[436] = t164;
    $[437] = t168;
    $[438] = t172;
    $[439] = t179;
    $[440] = t183;
    $[441] = t187;
    $[442] = t196;
    $[443] = t199;
    $[444] = t20;
    $[445] = t24;
    $[446] = t31;
    $[447] = t35;
    $[448] = t42;
    $[449] = t53;
    $[450] = t200;
  } else {
    t200 = $[450];
  }
  let t201;
  if ($[451] !== menuPromoBanners || $[452] !== t200 || $[453] !== t5 || $[454] !== t7 || $[455] !== t9) {
    t201 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} sections={t200} />;
    $[451] = menuPromoBanners;
    $[452] = t200;
    $[453] = t5;
    $[454] = t7;
    $[455] = t9;
    $[456] = t201;
  } else {
    t201 = $[456];
  }
  return t201;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('dobirka');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoPaymentOnDelivery']))
    }
  };
};